import { atom } from 'recoil';
export const surveyListState = atom({
    key: 'surveyListState',
    default: {
        surveys: [],
        error: '',
        reload: false
    }
});
